import React from "react";

const Hero = () => {
  return (
    <section className="hero-section" id="hero">
      <video className="hero-video" autoPlay muted loop playsInline>
        <source src="/assets/v1.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="overlay">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="word word-1">MATCH.</span>
            <br />
            <span className="word word-2">WORK.</span>
            <br />
            <span className="word word-3">GROW.</span>
          </h1>
          <p className="hero-slogan">
            Zugang zu hochqualifizierten Talenten <br/>- schnell, flexibel und ohne langfristige Bindung.<br />
          </p>
          <p className="hero-slogan">
            Qlance unterstützt Unternehmen bei strategischen und operativen Projekten durch passgenaue gematchte Top-Talente aus führenden Business Schools.
          </p>
          <button
            className="btn" id="home1-section"
            onClick={() =>
              document.getElementById("contact")?.scrollIntoView({
                behavior: "smooth",
              })
            }
          >
            <div>KONTAKT AUFNEHMEN</div>

          </button>
        </div>

        {/* Scroll-Button unten zentriert */}
        <div className="scroll-button-wrapper">
          <button
            className="button"
            onClick={() =>
              document.getElementById("home1-section")?.scrollIntoView({
                behavior: "smooth",
              })
            }
          >
            <div className="line one">
              <div className="round"></div>
              <div className="round"></div>
              <div className="round"></div>
              <div className="round"></div>
            </div>
            <div className="line two">
              <div className="round"></div>
              <div className="round"></div>
              <div className="round"></div>
              <div className="round"></div>
            </div>
            <div className="line three">
              <div className="round"></div>
              <div className="round"></div>
              <div className="round"></div>
              <div className="round"></div>
            </div>
            <div className="line four">
              <div className="round"></div>
              <div className="round"></div>
              <div className="round"></div>
              <div className="round"></div>
            </div>
            <div className="line five">
              <div className="round"></div>
              <div className="round"></div>
              <div className="round"></div>
              <div className="round"></div>
            </div>
            <div className="line six">
              <div className="round"></div>
              <div className="round"></div>
              <div className="round"></div>
              <div className="round"></div>
            </div>
            <div className="line seven">
              <div className="round"></div>
              <div className="round"></div>
              <div className="round"></div>
              <div className="round"></div>
            </div>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
